module.exports = __webpack_public_path__ + "static/media/bossCode.fdf0cd19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/bossCode.png
// module id = 165
// module chunks = 0